module.exports = __webpack_public_path__ + "img/Logo_fiponline_medium.3d603b89.png";